import React, { useState } from 'react';

import { Button } from 'antd';
import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';

import classNames from 'classnames';

import css from './FullScreenButton.module.scss';

const FullScreenButton = ({ iframeRef }) => {
  const currentRef = iframeRef?.current || iframeRef;
  const [isFullScreenEnabled, setIsFullScreenEnabled] = useState(false);

  const onResizeWindow = trigger => {
    if (!trigger) {
      currentRef.style.position = 'fixed';
      currentRef.style.top = '0';
      currentRef.style.left = '0';
      currentRef.style.bottom = '0';
      currentRef.style.right = '0';
      currentRef.style.width = '100%';
      currentRef.style.height = '100%';
      currentRef.style.zIndex = '9998';
    } else {
      currentRef.style.position = 'relative';
      currentRef.style.width = '100%';
      currentRef.style.height = '100%';
      currentRef.style.zIndex = '1';
    }
  };

  const changeState = () => {
    if (!isFullScreenEnabled) {
      setIsFullScreenEnabled(true);
    } else {
      setIsFullScreenEnabled(false);
    }
    onResizeWindow(isFullScreenEnabled);
  };

  return (
    <Button
      className={classNames(css.FullScreenButton, isFullScreenEnabled && css['FullScreenButton-active'])}
      onClick={changeState}
      icon={isFullScreenEnabled ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
      shape='circle'
      size='large'
      type='primary'
    />
  );
};

export default FullScreenButton;
